import { render, staticRenderFns } from "./PosturesByDeathReasonModal.vue?vue&type=template&id=5397df8e"
import script from "./PosturesByDeathReasonModal.vue?vue&type=script&lang=js"
export * from "./PosturesByDeathReasonModal.vue?vue&type=script&lang=js"
import style0 from "./PosturesByDeathReasonModal.vue?vue&type=style&index=0&id=5397df8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports